import $ from 'jquery';

var array_elementi_uno = $('.slider').length; // Gallery Sinistra Desktop
if ( array_elementi_uno > 0 ) {
  var slider_uno = new Splide( '.slider', {
    type   : 'fade',
    rewind: true,
    speed: 500,
    perMove: 1,
    gap: 0,
    arrows: false,
    pagination: false,
    drag: false,
    autoplay: true,
    interval: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
    resetProgress: false,
    slideFocus: true,
    height: '100vh',
    width: '50vw',
    breakpoints: {
      767: {
        height: '520px',
        width: '100vw',
      },
    }
  } ).mount();
  slider_uno.on('ready',function(){
    $( '.slider ').css('background-image', 'url(' + $( '.slider .splide__slide[tabindex="0"] img' ).attr('src') + ')');
  });
  slider_uno.on('moved',function(){
    $( '.slider ').css('background-image', 'url(' + $( '.slider .splide__slide[tabindex="0"] img' ).attr('src') + ')');
  });
}

var array_elementi_due = $('.sliderdue').length; // Gallery Destra Desktop
if ( array_elementi_due > 0 ) {
  var slider_due = new Splide( '.sliderdue', {
    type   : 'fade',
    rewind: true,
    speed: 500,
    perMove: 1,
    gap: 0,
    arrows: false,
    pagination: false,
    drag: false,
    autoplay: true,
    interval: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
    resetProgress: false,
    slideFocus: true,
    height: '100vh',
    width: '50vw',
    breakpoints: {
      767: {
        height: '520px',
        width: '100vw',
      },
    }
  } ).mount();
  slider_due.on('ready',function(){
    $( '.sliderdue ').css('background-image', 'url(' + $( '.sliderdue .splide__slide[tabindex="0"] img' ).attr('src') + ')');
  });
  slider_due.on('moved',function(){
    $( '.sliderdue ').css('background-image', 'url(' + $( '.sliderdue .splide__slide[tabindex="0"] img' ).attr('src') + ')');
  });
}

var array_elementi_tre = $('.slidertre').length; // Gallery Sinistra Mobile
if ( array_elementi_tre > 0 ) {
  var slider_tre = new Splide( '.slidertre', {
    type   : 'fade',
    rewind: true,
    speed: 500,
    perMove: 1,
    gap: 0,
    arrows: false,
    pagination: false,
    drag: false,
    autoplay: true,
    interval: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
    resetProgress: false,
    slideFocus: true,
    height: '100vh',
    width: '50vw',
    breakpoints: {
      767: {
        height: '520px',
        width: '100vw',
      },
    }
  } ).mount();
  slider_tre.on('ready',function(){
    $( '.slidertre ').css('background-image', 'url(' + $( '.slider .splide__slide[tabindex="0"] img' ).attr('src') + ')');
  });
  slider_tre.on('moved',function(){
    $( '.slidertre ').css('background-image', 'url(' + $( '.slider .splide__slide[tabindex="0"] img' ).attr('src') + ')');
  });
}

var array_elementi_quattro = $('.sliderquattro').length; // Gallery Destra Mobile
if ( array_elementi_quattro > 0 ) {
  var slider_quattro = new Splide( '.sliderquattro', {
    type   : 'fade',
    rewind: true,
    speed: 500,
    perMove: 1,
    gap: 0,
    arrows: false,
    pagination: false,
    drag: false,
    autoplay: true,
    interval: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
    resetProgress: false,
    slideFocus: true,
    height: '100vh',
    width: '50vw',
    breakpoints: {
      767: {
        height: '520px',
        width: '100vw',
      },
    }
  } ).mount();
  slider_quattro.on('ready',function(){
    $( '.sliderquattro ').css('background-image', 'url(' + $( '.slider .splide__slide[tabindex="0"] img' ).attr('src') + ')');
  });
  slider_quattro.on('moved',function(){
    $( '.sliderquattro ').css('background-image', 'url(' + $( '.slider .splide__slide[tabindex="0"] img' ).attr('src') + ')');
  });
}

$(window).load(function() {
  if( $(window).width() > 1920.5 || $(window).width() < 767.5 ) {
    check_img_exceedings();
  }
});

$( window ).on( "resize", function() {
  check_img_exceedings();
});

function check_img_exceedings() {
  if( $(window).width() > 767.5 ) {
	  var proporzione_img = 960 / 1080;
	  var proporzione_contenitore = ($(window).width() / 2) / $(window).height();
  } else {
	  var proporzione_img = 720 / 1014;
	  var proporzione_contenitore = $(window).width() / 520;
  }
  if(proporzione_img >= proporzione_contenitore) {
    $('.splide__slide img').removeClass('fixWidth');
    $('.splide__slide img').addClass('fixHeight');
	} else {
    $('.splide__slide img').removeClass('fixHeight');
    $('.splide__slide img').addClass('fixWidth');
	}
}


// WEBPACK FOOTER //
// ../views/blocks/slider-homepage/slider-homepage.js